import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../../data/navigation';
import { Ticker } from './Ticker';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  return <header className="sticky top-0 z-40 bg-bg/95 backdrop-blur supports-[backdrop-filter]:bg-bg/85" data-id="element-241" data-mp="7662pr66hydt">
      <Ticker data-id="element-242" data-mp="b7hk59ewfdax" />
      <div className="border-b border-line" data-id="element-243" data-mp="g0kj5x2g3eyi">
        <div className="mx-auto flex h-14 max-w-[1400px] items-center justify-between gap-6 px-5 md:px-8" data-id="element-244" data-mp="g1vhhhd4fui8">
          <Link to="/" className="flex items-baseline gap-3 whitespace-nowrap" data-id="element-245" data-mp="kz5izvdsbwmf">
            <span className="font-serif text-xl text-ink" data-id="element-246" data-mp="pzt5q4uzdrau">Agent Census</span>
            <span className="hidden font-mono text-[10.5px] text-muted sm:inline lg:hidden 2xl:inline" data-id="element-247" data-mp="uxbjq9nuuwpp">Machine Population Observatory</span>
          </Link>
          <nav aria-label="Primary" className="hidden lg:block" data-id="element-248" data-mp="1s58ofaqv24m">
            <ul className="flex items-center gap-1" data-id="element-249" data-mp="3szhux8qhi5re">
              {navItems.map(item => <li key={item.to} data-id="element-250" data-mp="3o2hjeiav8asw">
                  <NavLink to={item.to} end={item.end} className={({
                isActive
              }) => `relative block whitespace-nowrap px-2 py-2 text-[13px] transition-colors duration-150 ease-out xl:px-2.5 xl:text-[13.5px] ${isActive ? 'text-ink after:absolute after:inset-x-2 after:-bottom-[9px] after:h-[2px] after:bg-machine' : 'text-muted hover:text-ink'}`} data-id="element-251" data-mp="3o3ixywr3bffd">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
          </nav>
          <button type="button" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-line text-ink lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(o => !o)} data-id="element-252" data-mp="yjz61z5aecwk">
            {open ? <XIcon className="h-4 w-4" data-id="element-253" data-mp="2j0p1om2vxk9w" /> : <MenuIcon className="h-4 w-4" data-id="element-254" data-mp="2o14cb5vs8do6" />}
          </button>
        </div>
        <AnimatePresence data-id="element-255" data-mp="2a1uxa9jbbpls">
          {open && <motion.nav id="mobile-nav" aria-label="Primary" initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} className="border-t border-line lg:hidden" data-id="element-256" data-mp="2a120a0a5oegu">
              <ul className="mx-auto grid max-w-[1400px] grid-cols-2 gap-px px-5 py-3 sm:grid-cols-4" data-id="element-257" data-mp="3uh6orvkleajv">
                {navItems.map(item => <li key={item.to} data-id="element-258" data-mp="3am2ep5hfqt6">
                    <NavLink to={item.to} end={item.end} className={({
                isActive
              }) => `block rounded px-3 py-2.5 text-sm ${isActive ? 'bg-raised text-ink' : 'text-muted hover:text-ink'}`} data-id="element-259" data-mp="1ntfu57uqmsw8">
                      {item.label}
                    </NavLink>
                  </li>)}
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}